
/**
 * Randomly display tooltip texts for category balloons
 */

export default {

    conf: {
        identifier: '[data-category-balloons]',
        tipDisplayTime: 4000,
    },

    init: function() {
        let containers = $(this.conf.identifier);
        let displayTime = this.conf.tipDisplayTime;

        containers.each((index, container) => {

            let balloonItems = $(container).children();

            let lastItemPos = undefined;
            let randomPos = undefined;

            function displayRandomTooltip() {

                // Avoid showing same position multiple times in a row
                while(randomPos == lastItemPos) {
                    randomPos = Math.floor(Math.random() * balloonItems.length);
                }
                lastItemPos = randomPos;

                let randomItem = balloonItems.eq(randomPos);
                let tooltipText = randomItem.children('[data-category-balloon-tooltip]');

                tooltipText.addClass('c-category-balloons__tooltip--visible');

                setTimeout(function() {
                    tooltipText.removeClass('c-category-balloons__tooltip--visible');
                }, displayTime);
            }

            displayRandomTooltip();
            setInterval(displayRandomTooltip, this.conf.tipDisplayTime + 1000);
        });

    }
}